import lodash from 'lodash';
const { omit } = lodash;
export default context => {
    return omit(context, ['eventBoundaryContext', 'session', 'hNode']);
};
